import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSign = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#787887"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M2 13.8c1.008-.07 1.913-.23 2.885-.596 2.265-.853 4.681-2.085 6.446-3.974.49-.527 1.155-1.511.834-2.36-.241-.637-.976-.922-1.535-.862-2.33.247-3.28 3.496-3.025 5.767.39 3.478 4.149 3.814 6.432 2.553 1.678-.928 2.856-2.853 3.855-4.587.07-.12.125-.256.217-.354.03-.032.01.092 0 .137-.13.57-.317 1.123-.434 1.699-.15.73-.305 1.593.084 2.271.409.714 1.163 1.075 1.886.886.88-.23 1.726-.944 2.355-1.667M4 20c2.912-.6 5.79-.942 8.8-.991 2.116-.035 4.177.01 6.2.529M15 5a8.3 8.3 0 0 1 2-1"
    />
  </svg>
);
export default SvgSign;
